import { DotData } from '../Dots'

export const getDots = (amount: number, filledAmount: number): DotData[] => new Array(amount)
    .fill(null)
    .map((value, index) => ({
        id: index.toString(),
        isFilled: index < filledAmount,
    }))
